import { rotinasConvocacaoAtiva } from "~/composables/menus/rotinas/convocacaoAtiva/rotinas";

export default function () {
  return rotinasConvocacaoAtiva;
}
